/**
 * Notification Service
 * Handles user notifications API calls
 */

import apiClient from './api.service';

const NOTIFICATION_BASE_URL = '/stores';

const notificationService = {
  /**
   * Get all notifications for current user
   */
  async getNotifications(storeId: number, params?: { limit?: number; offset?: number; is_read?: boolean }): Promise<any[]> {
    const response = await apiClient.get(
      `${NOTIFICATION_BASE_URL}/${storeId}/notifications`,
      { params }
    );
    return response.data.data;
  },

  /**
   * Get unread count
   */
  async getUnreadCount(storeId: number): Promise<number> {
    const response = await apiClient.get(
      `${NOTIFICATION_BASE_URL}/${storeId}/notifications/unread-count`
    );
    return response.data.data.count;
  },

  /**
   * Mark notification as read
   */
  async markAsRead(storeId: number, notificationId: number): Promise<any> {
    const response = await apiClient.put(
      `${NOTIFICATION_BASE_URL}/${storeId}/notifications/${notificationId}/read`
    );
    return response.data.data;
  },

  /**
   * Mark all notifications as read
   */
  async markAllAsRead(storeId: number): Promise<number> {
    const response = await apiClient.put(
      `${NOTIFICATION_BASE_URL}/${storeId}/notifications/read-all`
    );
    return response.data.data.count;
  },

  /**
   * Delete a notification
   */
  async deleteNotification(storeId: number, notificationId: number): Promise<any> {
    const response = await apiClient.delete(
      `${NOTIFICATION_BASE_URL}/${storeId}/notifications/${notificationId}`
    );
    return response.data.data;
  }
};

export default notificationService;

